/**
 * Rundenuhr-Format `M:SS`. Editor und Quickview zeigen dieselben Timings an —
 * Formatierung und Parsing liegen deshalb in einem gemeinsamen Modul statt
 * doppelt in beiden Rendering-Stacks.
 */
const countdownPattern = /^(\d{1,2}):([0-5]\d)$/;

export const timingFormatHint = "FORMAT M:SS";

export function formatCountdown(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return "–:––";
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${minutes}:${String(remainder).padStart(2, "0")}`;
}

/** `M:SS` → Sekunden. `null` bedeutet: Eingabe hat nicht das erwartete Format. */
export function parseCountdown(value: string): number | null {
  const match = countdownPattern.exec(value.trim());
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}
